var exports = {
  "x": "x43aef4ae--2511c3--marker",
  "G": "x43aef4ae--2511c3--tooltip-content",
};

module.exports = exports;
